import { documentApi } from '../api';
import { ACTION_TYPES } from 'app/modules/document/service/store/actions';
import { IDocument } from '../model/document.model';
import { getPaperAndDocument } from 'app/modules/claim/service';

export const uploadDocuments = (documents: IDocument[]) => async (dispatch, getState) => {
  const { claimNumber, subscriptionNumber } = await getState().claim.claimModel.claim;
  if (documents.length) {
    await dispatch({
      type: ACTION_TYPES.UPLOAD_DOCUMENTS,
      payload: documentApi.uploadDocuments(documents),
    });

    await dispatch(getPaperAndDocument(subscriptionNumber, claimNumber));
  }
};
